<!-- <div
  *ngIf="visible"
  class="position-fixed start-0 end-0 p-3 mb-4"
  style="bottom: 0; z-index: 1080;"
>
  <div
    class="container"
    role="dialog"
    aria-label="Cookie consent"
    aria-live="polite"
  >
    <div class="card shadow-sm border-0"  style="background-color: #efefef;">
      <div class="card-body d-flex flex-column flex-md-row gap-1 align-items-start align-items-md-center justify-content-between">
        <div class="me-md-3">
          <div class="fw-bold mb-1">We use cookies</div>
          <div class="text-muted small mb-0">
            We use cookies to improve your experience, analyze traffic, and personalize content.
            You can accept all cookies or reject non-essential cookies.
            <a routerLink="/privacy-policy" class="link-primary text-decoration-none">
              Learn more
            </a>
          </div>
        </div>

        <div class="d-flex gap-2 flex-shrink-0">
            <button class="btn btn-outline-secondary rounded-pill px-4" (click)="reject()">Reject</button>
            <button class="btn btn-dark rounded-pill px-4" (click)="acceptAll()">Accept all</button>
        </div>
      </div>
    </div>
  </div>
</div> -->


<div *ngIf="visible" class="cookie-wrapper">
  <div
    class="cookie-container"
    role="dialog"
    aria-label="Cookie consent"
    aria-live="polite"
  >
    <div class="cookie-card">
      <div class="cookie-body">
        <div class="cookie-text">
          <div class="cookie-title">We use cookies</div>
          <div class="cookie-desc">
            We use cookies to improve your experience, analyze traffic, and personalize content.
            You can accept all cookies or reject non-essential cookies.
            <a routerLink="/privacy-policy" class="cookie-link">Learn more</a>
          </div>
        </div>

        <div class="cookie-actions">
          <button class="btn-reject" (click)="reject()">Reject</button>
          <button class="btn-accept" (click)="acceptAll()">Accept all</button>
        </div>
      </div>
    </div>
  </div>
</div>
